module.exports = __webpack_public_path__ + "img/bank_transfer_and_counter_payment.6cd30976.png";